import { styled } from '@mui/system'
import { Grid } from '@mui/material'

export const GridWithMargin = styled(Grid)({
  marginTop: '10px',
})
